// removed by extract-text-webpack-plugin
module.exports = {"header-bg-color":"#8c1515","header-fg-color":"#fffeff","header-navbar-bg-color":"#F0F0E8","header-navbar-fg-color":"#8c1515","header-navbar-border-color":"#D4CFB4","layout":"_11mkEuuH1WKMtclIlApUju","header":"cZX6ceAG_f0P5N-F38lpa","container":"YWHiDJTKZL6f1La4Lj7W3","headerLink":"_3EAVZ_Wd-h57SmBsb3_v8p YWHiDJTKZL6f1La4Lj7W3","navbar":"tbL281mXaShDL-4xpmooP","navbarList":"lyWNE39kz2I_If1bANUfa YWHiDJTKZL6f1La4Lj7W3","gtip":"_3woVYfsGQ5P1eCgwiTxnKM","navbarLink":"_2T6jdf7UUF6A5MfqRKZ-Th","pullRight":"_24cxp50FFax81_3WB8Eu2z"};


//////////////////
// WEBPACK FOOTER
// ./src/views/layout/style.css
// module id = 650
// module chunks = 0